module.exports = __webpack_public_path__ + "static/3-a064e5ad87d5233a3854743e217fbf6c.png";